import Content from '../../content';

namespace('IO.Views.Preferences', function (exports) {
  'use strict';

  var Edit = Content.extend({
    // eslint-disable-line newline-after-var

    dom: {
      PREFERENCES_FORM: '.custom.io-form',
      FIELDS:
        '#preference-page input[type="checkbox"]:not(#manage_by_hierarchy)',
      YELLOW_ROWS: '.pref-diff',
      WARNING: '#pref-warning',
      MANAGE_TEMPLATES_BY_HIERARCHY: '#preference_management_option',
      HIERARCHY_DEFINITION_FIELD: '#hierarchy-definition-selector',
      TAB_LINK: '.tabs a',
    },

    events: function () {
      var events = {};

      events['change ' + this.dom.FIELDS] = '_checkDiffValue';
      events['change ' + this.dom.MANAGE_TEMPLATES_BY_HIERARCHY] =
        '_toogleTemplateManagement';
      events['click ' + this.dom.TAB_LINK] = '_preventNavigation';
      events['submit ' + this.dom.PREFERENCES_FORM] = '_checkManagementChange';
      return events;
    },

    render: function () {
      this.checkWarning();
      this.initialManagementOption = $(
        this.dom.MANAGE_TEMPLATES_BY_HIERARCHY,
      ).val();
    },

    _checkManagementChange: function (e) {
      var managementOptionNotChanged =
        this.initialManagementOption ===
        $(this.dom.MANAGE_TEMPLATES_BY_HIERARCHY).val();

      if (
        managementOptionNotChanged ||
        $(e.target).hasClass('preferences-submit-triggered')
      ) {
        $(e.target).removeClass('preferences-submit-triggered');
        return true;
      }

      e.preventDefault();

      this._confirmManagementChange(function () {
        $(e.target).addClass('preferences-submit-triggered');
        $(e.target).submit();
      });
      return false;
    },

    _confirmManagementChange: function (proceedCallback) {
      var confirmModal =
        new IO.Views.Preferences.ManagementChangesConfirmation();

      confirmModal.open();
      confirmModal.answer(function (proceed) {
        if (proceed) {
          proceedCallback();
        }
        confirmModal.destroy();
      });
    },

    checkWarning: function () {
      if ($(this.dom.YELLOW_ROWS).length > 0) {
        $(this.dom.WARNING).removeClass('hidden');
      } else {
        $(this.dom.WARNING).addClass('hidden');
      }
    },

    _toogleTemplateManagement: function (e) {
      var hierarchyDefionitionOption = '2',
        selected = $(e.target).val() === hierarchyDefionitionOption,
        definitionField = $(this.dom.HIERARCHY_DEFINITION_FIELD),
        parents = definitionField.parents('tr');

      if (selected) {
        parents.removeClass('hidden');
        return;
      }

      parents.addClass('hidden');
      definitionField.find('option').attr('selected', false);
      definitionField.find('option:eq(0)').attr('selected', true);
      definitionField.trigger('change');
    },

    _preventNavigation: function (e) {
      e.preventDefault();
    },

    _checkDiffValue: function (e) {
      var field = $(e.target),
        fieldValue = field.is(':checked'),
        fieldName = field.attr('name').split('[')[1].replace(']', '');

      if (currentPreference.id != globalPreference.id) {
        if (globalPreference[fieldName] != fieldValue) {
          field.parents('tr').addClass('pref-diff');
        } else {
          field.parents('tr').removeClass('pref-diff');
        }
        this.checkWarning();
      }
    },
  });
  exports.Edit = Edit;
});
